import { useEffect, useRef, useState } from "react";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import UserNotification from "util/UserNotification";
import { assistantHistoryQueryKey } from "ai/hooks/constants";
import applyToolEvent from "ai/hooks/toolCallProgress";
import streamAssistantRequest from "ai/hooks/streamAssistantRequest";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
const useAskAssistant = ({ onSuccess = () => {
} } = {}) => {
  const queryClient = useQueryClient();
  const sendTelemetry = useSendTelemetry();
  const [toolCalls, setToolCalls] = useState([]);
  const running = useRef(null);
  useEffect(() => () => {
    var _a;
    return (_a = running.current) == null ? void 0 : _a.abort();
  }, []);
  const {
    mutateAsync,
    isPending: isLoading,
    isError,
    error
  } = useMutation({
    // A new request replaces the running one, so their tool calls never mix.
    mutationFn: (request) => {
      var _a;
      (_a = running.current) == null ? void 0 : _a.abort();
      const controller = new AbortController();
      running.current = controller;
      setToolCalls([]);
      return streamAssistantRequest(
        request,
        (event) => {
          if (!controller.signal.aborted) {
            setToolCalls((calls) => applyToolEvent(calls, event));
          }
        },
        controller.signal
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: assistantHistoryQueryKey
      });
      onSuccess();
    },
    onError: (e) => {
      if (e.name === "AbortError") {
        return;
      }
      sendTelemetry(TELEMETRY_EVENT_TYPE.WIDGET_SUMMARY.REQUEST_FAILURE, {});
      UserNotification.error(e.message);
    }
  });
  return {
    request: (request) => mutateAsync(request),
    isLoading,
    isError,
    error,
    toolCalls
  };
};
export default useAskAssistant;
